import { forwardRef, useImperativeHandle } from 'react';
import { useInstantSearch } from 'react-instantsearch';

export interface RefreshTriggerHandleRef {
  refresh: () => void;
}

const RefreshTrigger = forwardRef<RefreshTriggerHandleRef>((props, ref) => {
  const { refresh } = useInstantSearch();

  useImperativeHandle(ref, () => ({
    refresh,
  }));

  return null;
});

RefreshTrigger.displayName = 'RefreshTrigger';

export default RefreshTrigger;
